<div class="tg-widget-host"
    [ngClass]="widgetHostRootNgClass()"
    [style.--tg-accent]="metaPrimary()"
    [style.--tg-secondary]="metaSecondary()"
    [style.--tg-action]="metaAction()">

    @if (isOpen()) {
    <div [attr.data-widget-theme]="widgetDarkTheme() ? 'dark' : 'light'" [class]="panelShellClass()"
        [style.background]="widgetBackgroundColor()"
        [style.borderRadius.px]="panelBorderRadiusPx()">

        @if (sessionStarted() && chatHeaderEnabled() && !showFeedbackForm()) {
        <header
            [class]="'flex items-center gap-2 px-3 py-3 shrink-0 ' + widgetTopChromeInsetClass()"
            [style.background]="metaPrimary()">
            <button type="button" (click)="toggleChat()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/15 transition-colors shrink-0"
                aria-label="Minimize">
                <i class="fa-solid fa-chevron-down text-sm"></i>
            </button>
            <div class="relative shrink-0">
                <img
                    [src]="widgetBotAvatarSrc()"
                    alt="" class="w-9 h-9 rounded-full object-cover ring-2 ring-white/30" />
                @if (!isHumanAgentPresent()) {
                <span class="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-emerald-400 ring-2 ring-white/40"></span>
                }
            </div>
            <div class="min-w-0 flex-1 pr-1">
                <h3 class="text-[15px] font-semibold leading-tight truncate m-0 text-white">
                    {{ widgetConfig()?.metaData?.chatbotDisplayName || 'Assistant' }}
                </h3>
                <p class="text-[14px] leading-snug truncate m-0 mt-0.5 text-white/70">
                    @if (isHumanAgentPresent()) {
                    {{ connectedHumanAgentsSubtitle()
                    ? ('Team: ' + connectedHumanAgentsSubtitle())
                    : 'A team member is here' }}
                    } @else {
                    {{ widgetConfig()?.metaData?.welcomeDescription }}
                    }
                </p>
            </div>
            @if (isChatMode()) {
            <button type="button" (click)="toggleSoundNotifications()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/15 transition-colors shrink-0"
                [attr.aria-pressed]="soundNotificationsEnabled()"
                [attr.aria-label]="soundNotificationsEnabled() ? 'Mute message notification sound' : 'Enable message notification sound'"
                [title]="soundNotificationsEnabled() ? 'Mute message sound' : 'Message sound off — tap to enable'">
                <i class="fa-solid text-sm"
                    [class.fa-bell]="soundNotificationsEnabled()"
                    [class.fa-bell-slash]="!soundNotificationsEnabled()"
                    [class.opacity-60]="!soundNotificationsEnabled()"></i>
            </button>
            }

            <!-- Three-dots menu -->
            <div class="relative shrink-0" (click)="$event.stopPropagation()">
                <button type="button" (click)="toggleHeaderMenu($event)"
                    class="w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/15 transition-colors"
                    aria-label="More options">
                    <i class="fa-solid fa-ellipsis text-base"></i>
                </button>
                @if (showHeaderMenu()) {
                <div
                    class="absolute right-0 top-full mt-1 min-w-[140px] rounded-xl shadow-xl border z-50 overflow-hidden"
                    [class.bg-white]="!widgetDarkTheme()" [class.border-zinc-200]="!widgetDarkTheme()"
                    [class.bg-neutral-800]="widgetDarkTheme()" [class.border-white/10]="widgetDarkTheme()">
                    <button type="button"
                        (click)="endSessionFromMenu()"
                        class="flex items-center gap-2.5 w-full px-4 py-2.5 text-sm font-medium text-red-500 hover:bg-red-50 active:bg-red-100 transition-colors"
                        [class.hover:bg-red-50]="!widgetDarkTheme()"
                        [class.hover:bg-red-500/10]="widgetDarkTheme()">
                        <i class="fa-solid fa-circle-xmark text-base"></i>
                        End chat
                    </button>
                </div>
                }
            </div>

            <button type="button" (click)="toggleChat()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/15 transition-colors shrink-0"
                aria-label="Minimize">
                <i class="fa-solid fa-minus text-sm"></i>
            </button>
        </header>

        <!-- click-outside overlay to close menu -->
        @if (showHeaderMenu()) {
        <div class="fixed inset-0 z-40" (click)="closeHeaderMenu()"></div>
        }
        }

        <div [class]="mainColumnClass()" [style.background]="widgetBackgroundColor()">

            <!-- ── Feedback form (shown after session ends) ── -->
            @if (showFeedbackForm()) {
            <!-- Feedback header -->
            <header [class]="'flex items-center gap-2 px-3 py-3 shrink-0 ' + widgetTopChromeInsetClass()"
                [style.background]="metaPrimary()">
                <button type="button" (click)="toggleChat()"
                    class="w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/15 transition-colors shrink-0"
                    aria-label="Minimize">
                    <i class="fa-solid fa-chevron-down text-sm"></i>
                </button>
                <div class="min-w-0 flex-1 pr-1">
                    <h3 class="text-[15px] font-semibold leading-tight truncate m-0 text-white">
                        Rate your experience
                    </h3>
                </div>
                <button type="button" (click)="skipFeedback()"
                    class="w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/15 transition-colors shrink-0"
                    aria-label="Close">
                    <i class="fa-solid fa-xmark text-base"></i>
                </button>
            </header>
            <div class="flex flex-col flex-1 min-h-0 px-5 py-6 overflow-y-auto"
                [class.tg-scroll-light]="!widgetDarkTheme()" [class.tg-scroll-dark]="widgetDarkTheme()">

                @if (feedbackSubmitted()) {
                <!-- Thank-you screen -->
                <div class="flex flex-col items-center justify-center flex-1 text-center gap-4 py-8">
                    <div class="w-16 h-16 rounded-full flex items-center justify-center ring-1"
                        [class.bg-emerald-50]="!widgetDarkTheme()" [class.ring-emerald-200]="!widgetDarkTheme()"
                        [class.bg-emerald-900/40]="widgetDarkTheme()" [class.ring-emerald-500/30]="widgetDarkTheme()">
                        <i class="fa-solid fa-check text-2xl"
                            [class.text-emerald-600]="!widgetDarkTheme()" [class.text-emerald-400]="widgetDarkTheme()"></i>
                    </div>
                    <div>
                        <h3 class="text-[17px] font-semibold m-0 mb-1"
                            [style.color]="widgetHeadingTextColor()">Thank you!</h3>
                        <p class="text-[13px] m-0 leading-relaxed"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            Your feedback helps us improve.
                        </p>
                    </div>
                </div>
                } @else {
                <!-- Feedback form content -->
                <div class="flex flex-col gap-6 pb-2">
                    <!-- Header -->
                    <div class="text-center">
                        <div class="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-3 ring-1"
                            [class.bg-zinc-100]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                            [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                            <i class="fa-regular fa-star text-xl"
                                [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-400]="widgetDarkTheme()"></i>
                        </div>
                        <h3 class="text-[17px] font-semibold m-0 mb-1.5 leading-tight"
                            [style.color]="widgetHeadingTextColor()">How was your experience?</h3>
                        <p class="text-[13px] m-0 leading-relaxed"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            Your feedback helps us get better.
                        </p>
                    </div>

                    <!-- Star rating -->
                    <div class="flex flex-col items-center gap-3">
                        <p class="text-[12px] font-semibold uppercase tracking-wider m-0"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            Rate your experience
                        </p>
                        <div class="flex items-center gap-2" role="group" aria-label="Rating">
                            @for (star of [1,2,3,4,5]; track star) {
                            <button type="button" (click)="selectFeedbackRating(star)"
                                class="w-11 h-11 flex items-center justify-center rounded-xl transition-all duration-150 text-xl"
                                [ngClass]="star <= feedbackRating()
                                    ? (widgetDarkTheme()
                                        ? 'bg-amber-500/20 text-amber-400 scale-110'
                                        : 'bg-amber-50 text-amber-500 scale-110')
                                    : (widgetDarkTheme()
                                        ? 'text-neutral-600 hover:text-amber-400 hover:bg-amber-500/10'
                                        : 'text-zinc-300 hover:text-amber-400 hover:bg-amber-50')"
                                [attr.aria-label]="star + ' star' + (star > 1 ? 's' : '')"
                                [attr.aria-pressed]="star <= feedbackRating()">
                                <i class="fa-star"
                                    [class.fa-solid]="star <= feedbackRating()"
                                    [class.fa-regular]="star > feedbackRating()"></i>
                            </button>
                            }
                        </div>
                        @if (feedbackRating() > 0) {
                        <p class="text-[12px] m-0"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            {{ feedbackRating() === 1 ? 'Very poor' : feedbackRating() === 2 ? 'Poor' : feedbackRating() === 3 ? 'Okay' : feedbackRating() === 4 ? 'Good' : 'Excellent' }}
                        </p>
                        }
                    </div>

                    <!-- Was issue resolved? -->
                    <div class="flex flex-col gap-2.5">
                        <p class="text-[12px] font-semibold uppercase tracking-wider m-0 text-center"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            Was your issue resolved?
                        </p>
                        <div class="flex gap-3">
                            <button type="button" (click)="selectFeedbackResolved(true)"
                                class="flex-1 h-11 rounded-xl text-[14px] font-medium flex items-center justify-center gap-2 transition-all ring-1"
                                [ngClass]="feedbackIsResolved() === true
                                    ? (widgetDarkTheme()
                                        ? 'bg-emerald-500/20 text-emerald-400 ring-emerald-500/40'
                                        : 'bg-emerald-50 text-emerald-700 ring-emerald-300')
                                    : (widgetDarkTheme()
                                        ? 'bg-neutral-800 text-neutral-300 ring-white/10 hover:bg-emerald-500/10 hover:text-emerald-400'
                                        : 'bg-zinc-50 text-zinc-600 ring-zinc-200 hover:bg-emerald-50 hover:text-emerald-700')"
                                aria-pressed="feedbackIsResolved() === true">
                                <i class="fa-solid fa-circle-check text-sm"></i>
                                Yes, resolved
                            </button>
                            <button type="button" (click)="selectFeedbackResolved(false)"
                                class="flex-1 h-11 rounded-xl text-[14px] font-medium flex items-center justify-center gap-2 transition-all ring-1"
                                [ngClass]="feedbackIsResolved() === false
                                    ? (widgetDarkTheme()
                                        ? 'bg-red-500/20 text-red-400 ring-red-500/40'
                                        : 'bg-red-50 text-red-700 ring-red-300')
                                    : (widgetDarkTheme()
                                        ? 'bg-neutral-800 text-neutral-300 ring-white/10 hover:bg-red-500/10 hover:text-red-400'
                                        : 'bg-zinc-50 text-zinc-600 ring-zinc-200 hover:bg-red-50 hover:text-red-700')"
                                aria-pressed="feedbackIsResolved() === false">
                                <i class="fa-solid fa-circle-xmark text-sm"></i>
                                Not resolved
                            </button>
                        </div>
                    </div>

                    <!-- Optional comment -->
                    <div class="flex flex-col gap-2">
                        <label class="text-[12px] font-semibold uppercase tracking-wider"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            Additional comments
                            <span class="normal-case font-normal opacity-70 ml-1">(optional)</span>
                        </label>
                        <textarea
                            [ngModel]="feedbackComment()" (ngModelChange)="feedbackComment.set($event)"
                            name="feedbackComment" rows="3"
                            placeholder="Tell us more about your experience…"
                            class="w-full px-3.5 py-2.5 rounded-xl border text-[14px] leading-relaxed resize-none focus:outline-none focus:ring-2 transition-all"
                            [class.border-zinc-200]="!widgetDarkTheme()"
                            [class.bg-zinc-50]="!widgetDarkTheme()"
                            [class.text-zinc-900]="!widgetDarkTheme()"
                            [class.placeholder-zinc-400]="!widgetDarkTheme()"
                            [class.focus:border-[var(--tg-accent)]/50]="!widgetDarkTheme()"
                            [class.focus:ring-[var(--tg-accent)]/15]="!widgetDarkTheme()"
                            [class.border-white/10]="widgetDarkTheme()"
                            [class.bg-neutral-800]="widgetDarkTheme()"
                            [class.text-neutral-100]="widgetDarkTheme()"
                            [class.placeholder-neutral-600]="widgetDarkTheme()"
                            [class.focus:border-[var(--tg-accent)]/40]="widgetDarkTheme()"
                            [class.focus:ring-[var(--tg-accent)]/20]="widgetDarkTheme()"></textarea>
                    </div>

                    <!-- Action buttons -->
                    <div class="flex flex-col gap-2 pt-1">
                        <button type="button" (click)="submitFeedback()"
                            [disabled]="feedbackRating() === 0 || feedbackIsResolved() === null || feedbackSubmitting()"
                            class="w-full h-12 rounded-xl text-[15px] font-semibold flex items-center justify-center gap-2 transition-all shadow-sm disabled:opacity-40 disabled:cursor-not-allowed"
                            [style.background]="metaPrimary()" [style.color]="preChatContinueTextColor()">
                            @if (feedbackSubmitting()) {
                            <span class="animate-spin inline-block h-4 w-4 rounded-full border-2 border-t-transparent opacity-70"></span>
                            <span>Submitting…</span>
                            } @else {
                            <i class="fa-solid fa-paper-plane text-sm"></i>
                            <span>Submit Feedback</span>
                            }
                        </button>
                        <button type="button" (click)="skipFeedback()"
                            class="w-full h-10 rounded-xl text-[13px] font-medium transition-colors"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.hover:text-zinc-700]="!widgetDarkTheme()"
                            [class.text-neutral-500]="widgetDarkTheme()" [class.hover:text-neutral-300]="widgetDarkTheme()">
                            Skip for now
                        </button>
                    </div>
                </div>
                }
            </div>
            }

            <div
                [class]="chatScrollAreaClass()"
                [style.backgroundColor]="widgetBackgroundColor() || null"
                #chatScrollContainer
                [class.hidden]="showFeedbackForm()">

                @if (isSocketRequestInProcess() && sessionStarted()) {
                <div class="flex flex-col items-center justify-center h-full min-h-[220px]">
                    <div class="relative mb-4">
                        <div class="w-16 h-16 rounded-full p-[3px]"
                            [style.background]="'linear-gradient(135deg, ' + metaPrimary() + 'aa, ' + metaPrimary() + '33)'">
                            <img
                                [src]="widgetBotAvatarSrc()"
                                alt="" class="w-full h-full rounded-full object-cover" />
                        </div>
                        <span class="absolute bottom-0 right-0 flex h-4 w-4">
                            <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60"
                                [style.background]="metaPrimary()"></span>
                            <span class="relative inline-flex rounded-full h-4 w-4"
                                [style.background]="metaPrimary()"></span>
                        </span>
                    </div>
                    <p class="text-[13px] font-medium"
                        [class.text-zinc-700]="!widgetDarkTheme()" [class.text-neutral-300]="widgetDarkTheme()">
                        Connecting…
                    </p>
                    <p class="text-[11px] mt-0.5"
                        [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                        Setting up your session
                    </p>
                </div>
                }

                @if (sessionStarted() && !isSocketRequestInProcess()) {
                <div class="space-y-4 pb-2">
                    @if (isAudioMode()) {
                    @if (widgetConfig()?.voiceEnabled) {
                    <div class="flex flex-col items-center justify-center py-6">
                        <div class="relative w-24 h-24 mb-6">
                            <!-- pulsing ring uses primary colour -->
                            <div class="absolute inset-0 rounded-full animate-ping"
                                [style.background]="metaPrimary() + '28'"></div>
                            <div class="relative w-24 h-24 rounded-full p-1 ring-1 ring-white/15"
                                [style.background]="'linear-gradient(135deg, ' + metaPrimary() + '55, ' + metaPrimary() + '20)'">
                                <img
                                    [src]="widgetBotAvatarSrc()"
                                    alt="" class="w-full h-full object-cover rounded-full" />
                            </div>
                            <span
                                class="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center ring-2"
                                [class.ring-white]="!widgetDarkTheme()" [class.ring-zinc-950]="widgetDarkTheme()">
                                <i class="fa-solid fa-microphone text-white text-xs"></i>
                            </span>
                        </div>
                        <p class="text-sm font-medium mb-1"
                            [class.text-zinc-800]="!widgetDarkTheme()" [class.text-neutral-300]="widgetDarkTheme()">Voice
                            call active</p>
                        <p class="text-xs mb-8" [class.text-zinc-500]="!widgetDarkTheme()"
                            [class.text-neutral-500]="widgetDarkTheme()">Speak naturally — we’re listening</p>
                        <div class="flex gap-3">
                            <button type="button" (click)="toggleMute()"
                                class="w-12 h-12 rounded-full flex items-center justify-center transition-colors ring-1"
                                [class.ring-zinc-200]="!widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()"
                                [ngClass]="isMuted() ? 'bg-red-500/15 text-red-400' : (widgetDarkTheme() ? 'bg-neutral-800 text-neutral-200 hover:bg-neutral-700' : 'bg-zinc-200 text-zinc-800 hover:bg-zinc-300')"
                                [disabled]="isSocketRequestInProcess()">
                                <i class="fa-solid" [class.fa-microphone]="!isMuted()"
                                    [class.fa-microphone-slash]="isMuted()"></i>
                            </button>
                            <button type="button" (click)="endSession()"
                                class="w-12 h-12 rounded-full bg-red-500/90 hover:bg-red-500 text-white flex items-center justify-center  transition-colors"
                                title="End call" aria-label="End call">
                                <i class="fa fa-phone-slash text-sm"></i>
                            </button>
                        </div>
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center py-6 px-4 text-center">
                        <div class="w-16 h-16 rounded-full flex items-center justify-center mb-4 ring-1"
                            [class.bg-amber-500/15]="!widgetDarkTheme()" [class.ring-amber-500/30]="!widgetDarkTheme()"
                            [class.bg-amber-950/40]="widgetDarkTheme()" [class.ring-amber-500/25]="widgetDarkTheme()">
                            <i class="fa-solid fa-microphone-slash text-2xl"
                                [class.text-amber-700]="!widgetDarkTheme()" [class.text-amber-300]="widgetDarkTheme()"></i>
                        </div>
                        <p class="text-sm font-medium mb-1"
                            [class.text-zinc-800]="!widgetDarkTheme()" [class.text-neutral-200]="widgetDarkTheme()">Voice
                            session</p>
                        <p class="text-xs mb-6 max-w-[260px] leading-relaxed"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">Voice
                            is turned off in widget settings. End the session when you’re done.</p>
                        <button type="button" (click)="endSession()"
                            class="w-12 h-12 rounded-full bg-red-500/90 hover:bg-red-500 text-white flex items-center justify-center transition-colors"
                            title="End call" aria-label="End call">
                            <i class="fa fa-phone-slash text-sm"></i>
                        </button>
                    </div>
                    }
                    }

                    <!-- Empty state: session connected but no messages yet -->
                    @if (responses().length === 0 && !isAudioMode() && !aiAssistantTyping() && !humanAgentTyping()) {
                    <div class="flex flex-col items-center justify-center h-full min-h-[200px] text-center py-10 px-4">
                        <div class="relative mb-4">
                            <div class="w-16 h-16 rounded-full p-[3px] shadow-md"
                                [style.background]="'linear-gradient(135deg, ' + metaPrimary() + 'aa, ' + metaPrimary() + '33)'">
                                <img
                                    [src]="widgetBotAvatarSrc()"
                                    alt="" class="w-full h-full rounded-full object-cover" />
                            </div>
                            <span class="absolute bottom-0 right-0 w-3 h-3 rounded-full bg-emerald-400 ring-2"
                                [class.ring-white]="!widgetDarkTheme()" [class.ring-neutral-900]="widgetDarkTheme()"></span>
                        </div>
                        <h3 class="text-[15px] font-semibold m-0 mb-1.5 leading-tight"
                            [style.color]="widgetHeadingTextColor()">
                            {{ widgetConfig()?.metaData?.chatbotDisplayName || 'Assistant' }}
                        </h3>
                        <p class="text-[13px] m-0 leading-relaxed max-w-[200px]"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-400]="widgetDarkTheme()">
                            {{ widgetConfig()?.metaData?.welcomeDescription || 'How can I help you today?' }}
                        </p>
                    </div>
                    }

                    @for (response of responses(); track $index) {
                    @if (response.kind === chatMessageKind.HistoryDivider) {
                    <div class="flex justify-center py-2 px-2" role="status">
                        <span
                            class="text-[11px] text-center leading-snug max-w-[95%] px-3 py-1.5 rounded-full"
                            [class.text-zinc-500]="!widgetDarkTheme()"
                            [class.bg-zinc-100]="!widgetDarkTheme()"
                            [class.text-neutral-500]="widgetDarkTheme()"
                            [class.bg-neutral-800/80]="widgetDarkTheme()">
                            {{ response.text }}
                        </span>
                    </div>
                    }
                    @if (response.kind === chatMessageKind.DayDivider) {
                    <div class="flex justify-center py-1.5 px-2" role="status">
                        <span
                            class="text-[11px] text-center leading-snug px-3 py-0.5 rounded-full shadow-sm"
                            [class.text-zinc-500]="!widgetDarkTheme()"
                            [class.bg-zinc-100]="!widgetDarkTheme()"
                            [class.text-neutral-400]="widgetDarkTheme()"
                            [class.bg-neutral-800/90]="widgetDarkTheme()">
                            {{ response.text }}
                        </span>
                    </div>
                    }
                    @if (response.kind === chatMessageKind.HumanJoined) {
                    <div class="flex justify-center py-1" role="status">
                        <div
                            class="inline-flex items-center gap-2.5 px-3 py-2 rounded-full ring-1 max-w-[95%]"
                            [class.bg-zinc-100]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                            [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                            @if (response.joinAgentImageUrl) {
                            <img [src]="response.joinAgentImageUrl" alt=""
                                class="w-8 h-8 rounded-full object-cover shrink-0" referrerpolicy="no-referrer" />
                            } @else {
                            <span
                                class="w-8 h-8 rounded-full bg-[var(--tg-accent)]/30 text-[var(--tg-accent)] text-xs font-bold flex items-center justify-center shrink-0">
                                {{ (response.joinAgentName || '?').charAt(0).toUpperCase() }}
                            </span>
                            }
                            <span class="text-left text-[13px]">
                                <span class="font-medium"
                                    [class.text-zinc-900]="!widgetDarkTheme()"
                                    [class.text-neutral-200]="widgetDarkTheme()">{{ response.joinAgentName || 'Team member'
                                    }}</span>
                                <span [class.text-zinc-500]="!widgetDarkTheme()"
                                    [class.text-neutral-500]="widgetDarkTheme()"> · {{ response.joinWatchingOnly ? 'viewing' : 'joined'
                                    }}</span>
                            </span>
                        </div>
                    </div>
                    }
                    @if (response.kind === chatMessageKind.HumanLeft) {
                    <div class="flex justify-center py-1" role="status">
                        <div
                            class="text-[12px] text-center px-4 py-2 rounded-full max-w-[92%] leading-relaxed break-words min-w-0"
                            [class.text-zinc-600]="!widgetDarkTheme()" [class.bg-zinc-100]="!widgetDarkTheme()"
                            [class.text-neutral-500]="widgetDarkTheme()" [class.bg-neutral-900]="widgetDarkTheme()"
                            [innerHTML]="response.text | parseMessageHtml">
                        </div>
                    </div>
                    }
                    @if (response.fromAi && !response.fromHuman && !response.kind) {
                    <div class="flex items-start gap-2.5 max-w-[92%]">
                        <img
                            [src]="widgetBotAvatarSrc()"
                            alt=""
                            class="w-7 h-7 rounded-full object-cover ring-1 shrink-0 mt-0.5"
                            [class.ring-zinc-200]="!widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()" />
                        <div class="min-w-0 flex-1">
                            @if (response.voiceAttachment; as va) {
                            <div class="rounded-2xl rounded-tl-md px-3 py-2.5 min-w-[200px] max-w-[260px] ring-1"
                                [class.bg-white]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                                [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                                <div class="flex items-center gap-1.5 mb-1.5">
                                    <i class="fa-solid fa-microphone text-xs"
                                        [class.text-zinc-500]="!widgetDarkTheme()"
                                        [class.text-neutral-400]="widgetDarkTheme()"></i>
                                    <span class="text-[12px] font-medium"
                                        [class.text-zinc-500]="!widgetDarkTheme()"
                                        [class.text-neutral-400]="widgetDarkTheme()">Voice message</span>
                                </div>
                                <audio controls class="w-full" style="height:32px;min-width:0;" [src]="va.url" preload="none"></audio>
                            </div>
                            } @else if (messageAttachmentForDisplay(response); as aiAtt) {
                            @if (aiAtt.isImage) {
                            <div class="overflow-hidden rounded-2xl rounded-tl-md max-w-[min(100%,18rem)] ring-1"
                                [class.bg-white]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                                [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                                <img [src]="aiAtt.url" [alt]="aiAtt.fileName"
                                    class="block w-full max-h-56 object-contain cursor-zoom-in hover:opacity-90 transition-opacity"
                                    [class.rounded-2xl]="!messageAttachmentCaption(response)"
                                    referrerpolicy="no-referrer" loading="lazy"
                                    (click)="openLightbox(aiAtt.url)" />
                                @if (messageAttachmentCaption(response); as aiCap) {
                                <div
                                    class="px-3.5 py-2.5 text-[15px] leading-relaxed break-words border-t"
                                    [class.text-zinc-900]="!widgetDarkTheme()"
                                    [class.text-neutral-100]="widgetDarkTheme()"
                                    [class.border-zinc-200/80]="!widgetDarkTheme()"
                                    [class.border-white/10]="widgetDarkTheme()"
                                    [innerHTML]="aiCap | parseMessageHtml">
                                </div>
                                }
                            </div>
                            } @else {
                            <div
                                class="rounded-2xl rounded-tl-md p-2 min-w-0 w-max max-w-full overflow-hidden ring-1"
                                [class.bg-white]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                                [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                                <a [href]="aiAtt.url" target="_blank" rel="noopener noreferrer"
                                    class="text-[14px] font-medium break-all px-2 py-1 inline-block underline underline-offset-2"
                                    [class.text-zinc-900]="!widgetDarkTheme()"
                                    [class.text-neutral-100]="widgetDarkTheme()">{{ aiAtt.fileName }}</a>
                            </div>
                            }
                            } @else {
                            <div
                                class="rounded-2xl rounded-tl-md px-4 py-3 text-[15px] leading-relaxed ring-1 break-words min-w-0 w-fit"
                                [class.bg-white]="!widgetDarkTheme()" [class.text-zinc-900]="!widgetDarkTheme()"
                                [class.ring-zinc-200]="!widgetDarkTheme()"
                                [class.bg-neutral-800]="widgetDarkTheme()" [class.text-neutral-100]="widgetDarkTheme()"
                                [class.ring-white/10]="widgetDarkTheme()"
                                [innerHTML]="response.text | parseMessageHtml">
                            </div>
                            }
                            <p class="mt-1 text-[11px] pl-1"
                                [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                                {{ botDisplayName() }} · {{ formatMsgTime(response.sentAt) }}
                            </p>
                        </div>
                    </div>
                    }
                    @if (response.fromAi && response.fromHuman && !response.kind) {
                    <div class="max-w-[92%]">
                        <div class="flex items-start gap-2.5">
                            @if (response.senderImageUrl) {
                            <img [src]="response.senderImageUrl" alt=""
                                class="w-8 h-8 rounded-full object-cover shrink-0 mt-0.5 ring-1"
                                [class.ring-zinc-200]="!widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()"
                                referrerpolicy="no-referrer" />
                            } @else {
                            <div
                                class="w-8 h-8 rounded-full bg-emerald-600/25 text-emerald-400 flex items-center justify-center shrink-0 mt-0.5 text-xs">
                                <i class="fa-solid fa-user"></i>
                            </div>
                            }
                            <div class="min-w-0 flex-1">
                                @if (response.voiceAttachment; as va) {
                                <div class="rounded-2xl rounded-tl-md px-3 py-2.5 min-w-[200px] max-w-[260px] ring-1"
                                    [class.bg-emerald-50]="!widgetDarkTheme()" [class.ring-emerald-200]="!widgetDarkTheme()"
                                    [class.bg-emerald-950]="widgetDarkTheme()" [class.ring-emerald-500/20]="widgetDarkTheme()">
                                    <div class="flex items-center gap-1.5 mb-1.5">
                                        <i class="fa-solid fa-microphone text-xs"
                                            [class.text-emerald-700]="!widgetDarkTheme()"
                                            [class.text-emerald-300]="widgetDarkTheme()"></i>
                                        <span class="text-[12px] font-medium"
                                            [class.text-emerald-700]="!widgetDarkTheme()"
                                            [class.text-emerald-300]="widgetDarkTheme()">Voice message</span>
                                    </div>
                                    <audio controls class="w-full" style="height:32px;min-width:0;" [src]="va.url" preload="none"></audio>
                                </div>
                                } @else if (messageAttachmentForDisplay(response); as humAtt) {
                                @if (humAtt.isImage) {
                                <div class="overflow-hidden rounded-2xl rounded-tl-md max-w-[min(100%,18rem)] ring-1"
                                    [class.bg-emerald-50]="!widgetDarkTheme()" [class.ring-emerald-200]="!widgetDarkTheme()"
                                    [class.bg-emerald-950]="widgetDarkTheme()" [class.ring-emerald-500/20]="widgetDarkTheme()">
                                    <img [src]="humAtt.url" [alt]="humAtt.fileName"
                                        class="block w-full max-h-56 object-contain cursor-zoom-in hover:opacity-90 transition-opacity"
                                        [class.rounded-2xl]="!messageAttachmentCaption(response)"
                                        referrerpolicy="no-referrer" loading="lazy"
                                        (click)="openLightbox(humAtt.url)" />
                                    @if (messageAttachmentCaption(response); as humCap) {
                                    <div
                                        class="px-3.5 py-2.5 text-[15px] leading-relaxed break-words border-t"
                                        [class.text-zinc-900]="!widgetDarkTheme()"
                                        [class.text-neutral-100]="widgetDarkTheme()"
                                        [class.border-emerald-200/80]="!widgetDarkTheme()"
                                        [class.border-emerald-500/25]="widgetDarkTheme()"
                                        [innerHTML]="humCap | parseMessageHtml">
                                    </div>
                                    }
                                </div>
                                } @else if (isVideoAttachment(humAtt.url)) {
                                <div class="rounded-2xl rounded-tl-md px-3 py-2.5 min-w-[200px] max-w-[min(100%,18rem)] ring-1"
                                    [class.bg-emerald-50]="!widgetDarkTheme()" [class.ring-emerald-200]="!widgetDarkTheme()"
                                    [class.bg-emerald-950]="widgetDarkTheme()" [class.ring-emerald-500/20]="widgetDarkTheme()">
                                    <div class="flex items-center gap-1.5 mb-1.5">
                                        <i class="fa-solid fa-video text-xs"
                                            [class.text-emerald-700]="!widgetDarkTheme()"
                                            [class.text-emerald-300]="widgetDarkTheme()"></i>
                                        <span class="text-[12px] font-medium"
                                            [class.text-emerald-700]="!widgetDarkTheme()"
                                            [class.text-emerald-300]="widgetDarkTheme()">Video</span>
                                    </div>
                                    <video controls playsinline class="block w-full max-h-56 rounded-lg"
                                        [src]="humAtt.url" preload="metadata"></video>
                                </div>
                                } @else if (isAudioAttachment(humAtt.url)) {
                                <div class="rounded-2xl rounded-tl-md px-3 py-2.5 min-w-[200px] max-w-[260px] ring-1"
                                    [class.bg-emerald-50]="!widgetDarkTheme()" [class.ring-emerald-200]="!widgetDarkTheme()"
                                    [class.bg-emerald-950]="widgetDarkTheme()" [class.ring-emerald-500/20]="widgetDarkTheme()">
                                    <div class="flex items-center gap-1.5 mb-1.5">
                                        <i class="fa-solid fa-microphone text-xs"
                                            [class.text-emerald-700]="!widgetDarkTheme()"
                                            [class.text-emerald-300]="widgetDarkTheme()"></i>
                                        <span class="text-[12px] font-medium"
                                            [class.text-emerald-700]="!widgetDarkTheme()"
                                            [class.text-emerald-300]="widgetDarkTheme()">Voice message</span>
                                    </div>
                                    <audio controls class="w-full" style="height:32px;min-width:0;" [src]="humAtt.url" preload="none"></audio>
                                </div>
                                } @else {
                                <div
                                    class="rounded-2xl rounded-tl-md px-3 py-3 min-w-0 overflow-hidden w-fit max-w-full"
                                    [class.bg-emerald-50]="!widgetDarkTheme()"
                                    [class.bg-emerald-950]="widgetDarkTheme()">
                                    <a [href]="humAtt.url" target="_blank" rel="noopener noreferrer"
                                        class="text-[14px] font-medium break-all underline underline-offset-2"
                                        [class.text-emerald-800]="!widgetDarkTheme()"
                                        [class.text-emerald-200]="widgetDarkTheme()">{{ humAtt.fileName }}</a>
                                </div>
                                }
                                } @else {
                                <div
                                    class="rounded-2xl rounded-tl-md px-4 py-3 text-[15px] leading-relaxed ring-1 break-words min-w-0 w-fit"
                                    [class.bg-emerald-50]="!widgetDarkTheme()" [class.text-zinc-900]="!widgetDarkTheme()"
                                    [class.ring-emerald-200]="!widgetDarkTheme()"
                                    [class.bg-emerald-950]="widgetDarkTheme()" [class.text-neutral-100]="widgetDarkTheme()"
                                    [class.ring-emerald-500/20]="widgetDarkTheme()"
                                    [innerHTML]="response.text | parseMessageHtml">
                                </div>
                                }
                                <p class="mt-1 text-[11px] pl-1"
                                    [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                                    {{ response.senderName || 'Team' }} · {{ formatMsgTime(response.sentAt) }}
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                    @if (!response.fromAi && !response.kind) {
                    <div
                        class="flex flex-col items-end ml-auto shrink-0 max-w-[92%]"
                        [class.w-full]="!messageAttachmentForDisplay(response) && !response.voiceAttachment"
                        [class.w-fit]="!!messageAttachmentForDisplay(response) || !!response.voiceAttachment">
                        @if (response.voiceAttachment; as va) {
                        <div class="rounded-2xl rounded-tr-md px-3 pt-2.5 pb-2 min-w-[220px] max-w-[280px] ring-1"
                            [style.background]="'linear-gradient(145deg, ' + metaPrimary() + ', ' + metaPrimary() + 'CC)'"
                            [class.ring-black/10]="!widgetDarkTheme()"
                            [class.ring-white/15]="widgetDarkTheme()">
                            <div class="flex items-center gap-2 mb-2">
                                <span class="w-6 h-6 rounded-full flex items-center justify-center bg-white/20 shrink-0">
                                    <i class="fa-solid fa-microphone text-[11px]" [style.color]="metaSecondary()"></i>
                                </span>
                                <span class="text-[11px] font-medium opacity-80" [style.color]="metaSecondary()">Voice message</span>
                                @if (va.durationSec) {
                                <span class="text-[11px] opacity-60 ml-auto tabular-nums" [style.color]="metaSecondary()">{{ formatRecordingTime(va.durationSec) }}</span>
                                }
                            </div>
                            <audio controls class="w-full"
                                style="height:32px;min-width:0;"
                                [src]="va.blobUrl || va.url" preload="none">
                            </audio>
                        </div>
                        } @else if (messageAttachmentForDisplay(response); as visAtt) {
                        @if (visAtt.isImage) {
                        <div class="overflow-hidden rounded-2xl rounded-tr-md max-w-[min(18rem,100%)] ring-1 shadow-sm"
                            [style.background]="'linear-gradient(145deg, ' + metaPrimary() + ', ' + metaPrimary() + 'CC)'"
                            [class.ring-black/10]="!widgetDarkTheme()"
                            [class.ring-white/15]="widgetDarkTheme()">
                            <img [src]="visAtt.url" [alt]="visAtt.fileName"
                                class="block w-full max-h-56 object-contain cursor-zoom-in hover:opacity-90 transition-opacity"
                                [class.rounded-2xl]="!messageAttachmentCaption(response)"
                                referrerpolicy="no-referrer" loading="lazy"
                                (click)="openLightbox(visAtt.url)" />
                            @if (messageAttachmentCaption(response); as visCap) {
                            <div
                                class="px-3.5 py-2.5 text-[15px] leading-relaxed break-words border-t border-white/20"
                                [style.color]="metaSecondary()"
                                [innerHTML]="visCap | parseMessageHtml">
                            </div>
                            }
                        </div>
                        } @else if (isVideoAttachment(visAtt.url)) {
                        <div class="rounded-2xl rounded-tr-md px-3 pt-2.5 pb-2 min-w-[200px] max-w-[min(100%,18rem)] ring-1"
                            [style.background]="'linear-gradient(145deg, ' + metaPrimary() + ', ' + metaPrimary() + 'CC)'"
                            [class.ring-black/10]="!widgetDarkTheme()"
                            [class.ring-white/15]="widgetDarkTheme()">
                            <div class="flex items-center gap-2 mb-2">
                                <span class="w-6 h-6 rounded-full flex items-center justify-center bg-white/20 shrink-0">
                                    <i class="fa-solid fa-video text-[11px]" [style.color]="metaSecondary()"></i>
                                </span>
                                <span class="text-[11px] font-medium opacity-80" [style.color]="metaSecondary()">Video</span>
                            </div>
                            <video controls playsinline class="block w-full max-h-56 rounded-lg"
                                [src]="visAtt.url" preload="metadata"></video>
                        </div>
                        } @else if (isAudioAttachment(visAtt.url)) {
                        <!-- Audio from history: render as player (same style as live voice bubble) -->
                        <div class="rounded-2xl rounded-tr-md px-3 pt-2.5 pb-2 min-w-[220px] max-w-[280px] ring-1"
                            [style.background]="'linear-gradient(145deg, ' + metaPrimary() + ', ' + metaPrimary() + 'CC)'"
                            [class.ring-black/10]="!widgetDarkTheme()"
                            [class.ring-white/15]="widgetDarkTheme()">
                            <div class="flex items-center gap-2 mb-2">
                                <span class="w-6 h-6 rounded-full flex items-center justify-center bg-white/20 shrink-0">
                                    <i class="fa-solid fa-microphone text-[11px]" [style.color]="metaSecondary()"></i>
                                </span>
                                <span class="text-[11px] font-medium opacity-80" [style.color]="metaSecondary()">Voice message</span>
                            </div>
                            <audio controls class="w-full" style="height:32px;min-width:0;" [src]="visAtt.url" preload="none"></audio>
                        </div>
                        } @else {
                        <div
                            class="rounded-2xl rounded-tr-md p-2 min-w-0 w-max max-w-full overflow-hidden ring-1"
                            [style.background]="'linear-gradient(145deg, ' + metaPrimary() + ', ' + metaPrimary() + 'CC)'"
                            [class.ring-black/10]="!widgetDarkTheme()"
                            [class.ring-white/15]="widgetDarkTheme()">
                            <a [href]="visAtt.url" target="_blank" rel="noopener noreferrer"
                                class="text-[14px] font-medium break-all px-2 py-1 inline-block underline underline-offset-2"
                                [style.color]="metaSecondary()">{{ visAtt.fileName }}</a>
                        </div>
                        }
                        } @else {
                        <div
                            class="rounded-2xl rounded-tr-md px-4 py-3 text-[15px] leading-relaxed break-words min-w-0"
                            [style.background]="'linear-gradient(145deg, ' + metaPrimary() + ', ' + metaPrimary() + 'CC)'"
                            [style.color]="metaSecondary()"
                            [innerHTML]="response.text | parseMessageHtml">
                        </div>
                        }
                        <p class="mt-1 text-[11px] pr-1"
                            [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            {{ formatMsgTime(response.sentAt) }}
                        </p>
                    </div>
                    }
                    }

                    <!-- ── Typing indicators (WhatsApp-style: appear as last chat item) ── -->
                    @if (humanAgentTyping()) {
                    <div class="flex items-start gap-2.5 max-w-[92%]" role="status" aria-live="polite"
                        [attr.aria-label]="humanTypingAgentName() + ' is typing'">
                        <div
                            class="w-7 h-7 rounded-full bg-emerald-600/25 text-emerald-400 flex items-center justify-center shrink-0 mt-0.5 text-[11px] font-bold">
                            {{ (humanTypingAgentName() | slice:0:1).toUpperCase() }}
                        </div>
                        <div class="min-w-0">
                            <div class="rounded-2xl rounded-tl-md px-3.5 py-2.5 ring-1 inline-block"
                                [class.bg-emerald-50]="!widgetDarkTheme()" [class.ring-emerald-200]="!widgetDarkTheme()"
                                [class.bg-emerald-950]="widgetDarkTheme()" [class.ring-emerald-500/20]="widgetDarkTheme()">
                                <div class="flex gap-1.5 items-center"
                                    [class.text-emerald-600]="!widgetDarkTheme()"
                                    [class.text-emerald-300]="widgetDarkTheme()" aria-hidden="true">
                                    <span class="tg-typing-dot"></span>
                                    <span class="tg-typing-dot"></span>
                                    <span class="tg-typing-dot"></span>
                                </div>
                            </div>
                            <p class="mt-1 text-[11px] pl-1"
                                [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                                {{ humanTypingAgentName() }} is typing…
                            </p>
                        </div>
                    </div>
                    }
                    @if (agentTypingPhase() === 'tools' && aiAssistantTyping()) {
                    <div class="flex items-start gap-2.5 max-w-[92%]" role="status" aria-live="polite"
                        aria-label="Assistant is thinking">
                        <img
                            [src]="widgetBotAvatarSrc()"
                            alt="" class="w-7 h-7 rounded-full object-cover ring-1 shrink-0 mt-0.5"
                            [class.ring-zinc-200]="!widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()" />
                        <div class="min-w-0">
                            <div class="tg-wa-thinking-bubble rounded-2xl rounded-tl-md px-3.5 py-2.5 ring-1 inline-flex items-center gap-2.5"
                                [class.bg-white]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                                [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                                <div class="tg-wa-deep-dots flex gap-1 shrink-0 items-center"
                                    [class.text-zinc-500]="!widgetDarkTheme()"
                                    [class.text-neutral-400]="widgetDarkTheme()" aria-hidden="true">
                                    <span class="tg-typing-dot"></span>
                                    <span class="tg-typing-dot"></span>
                                    <span class="tg-typing-dot"></span>
                                </div>
                                <span class="text-[13px] font-medium leading-none whitespace-nowrap"
                                    [class.text-zinc-700]="!widgetDarkTheme()"
                                    [class.text-neutral-200]="widgetDarkTheme()">
                                    {{ agentTypingHint() || 'Deep thinking' }}
                                </span>
                            </div>
                            <p class="mt-1 text-[11px] pl-1"
                                [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                                {{ botDisplayName() }} is thinking…
                            </p>
                        </div>
                    </div>
                    } @else if (aiAssistantTyping()) {
                    <div class="flex items-start gap-2.5 max-w-[92%]" role="status" aria-live="polite"
                        aria-label="Assistant is typing">
                        <img
                            [src]="widgetBotAvatarSrc()"
                            alt="" class="w-7 h-7 rounded-full object-cover ring-1 shrink-0 mt-0.5"
                            [class.ring-zinc-200]="!widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()" />
                        <div class="min-w-0">
                            <div class="rounded-2xl rounded-tl-md px-3.5 py-2.5 ring-1 inline-block"
                                [class.bg-white]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                                [class.bg-neutral-800]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                                <div class="flex gap-1.5 items-center"
                                    [class.text-zinc-500]="!widgetDarkTheme()"
                                    [class.text-neutral-400]="widgetDarkTheme()" aria-hidden="true">
                                    <span class="tg-typing-dot"></span>
                                    <span class="tg-typing-dot"></span>
                                    <span class="tg-typing-dot"></span>
                                </div>
                            </div>
                            <p class="mt-1 text-[11px] pl-1"
                                [class.text-zinc-400]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                                {{ botDisplayName() }} is typing…
                            </p>
                        </div>
                    </div>
                    }
                </div>
                }

                @if (!sessionStarted() && !showFeedbackForm()) {
                <div
                    class="flex flex-col h-full min-h-0 px-4 py-0 -mx-4">
                    <div [class]="'flex items-center justify-end shrink-0 mb-2 ' + widgetTopChromeInsetClass()">
                        <button type="button" (click)="toggleChat()" class="tg-icon-btn" aria-label="Close">
                            <i class="fa-solid fa-xmark text-base"></i>
                        </button>
                    </div>

                    @if (showPreChatForm()) {
                    <!-- Chatwoot-style: compact header + labeled fields + card -->
                    <div class="flex flex-col flex-1 min-h-0 text-left w-full">
                        <!-- Colored hero banner -->
                        <div class="rounded-2xl px-4 pt-5 pb-4 mb-4 shrink-0 text-center relative overflow-hidden"
                            [style.background]="metaPrimary()">
                            <div class="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none"></div>
                            <div class="relative inline-block mb-2.5">
                                <img
                                    [src]="widgetBotAvatarSrc()"
                                    alt=""
                                    class="w-14 h-14 rounded-full object-cover ring-2 ring-white/40 shadow-lg" />
                                <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-400 ring-2 ring-white/60"></span>
                            </div>
                            <h3 class="text-[15px] font-semibold m-0 mb-0.5 text-white leading-tight">{{ welcomeHeadline() }}</h3>
                            <p class="text-[14px] m-0 text-white/70">{{ welcomeSubcopy() }}</p>
                        </div>

                        <p class="text-[14px] font-semibold m-0 mb-1 leading-snug tracking-tight"
                            [style.color]="widgetHeadingTextColor()">{{ preChatLeadIn() }}</p>
                        <p class="text-[14px] m-0 mb-4 leading-relaxed"
                            [class.text-zinc-500]="!widgetDarkTheme()"
                            [class.text-neutral-500]="widgetDarkTheme()">
                            We’ll use your contact details to follow up on your
                            <span class="font-semibold underline decoration-2 underline-offset-2"
                                [style.color]="metaPrimary()"
                                [style.text-decoration-color]="metaPrimary()">message</span>
                            when needed.
                        </p>

                        <div
                            class="tg-prechat-card rounded-2xl border p-4 mb-2 overflow-visible shadow-sm"
                            [class.border-zinc-200]="!widgetDarkTheme()"
                            [class.bg-white]="!widgetDarkTheme()"
                            [class.shadow-zinc-200/60]="!widgetDarkTheme()"
                            [class.border-white/10]="widgetDarkTheme()"
                            [class.bg-zinc-900]="widgetDarkTheme()"
                            [class.shadow-none]="widgetDarkTheme()"
                            [style.background]="widgetBackgroundColor() || null">
                            <form (ngSubmit)="submitPreChat()" class="space-y-5" >
                                <div>
                                    <label class="block text-[14px] font-bold mb-1.5 tracking-wide"
                                        [class.text-zinc-600]="!widgetDarkTheme()"
                                        [class.text-neutral-400]="widgetDarkTheme()">Full name</label>
                                    <input type="text" [ngModel]="preChatFullName()"
                                        (ngModelChange)="preChatFullName.set($event); validatePreChat()"
                                        name="fullNameInput" placeholder="Full name" autocomplete="name"
                                        class="tg-prechat-input w-full h-11 px-3.5 rounded-xl border text-[15px] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0"
                                        [class.border-zinc-200]="!widgetDarkTheme()"
                                        [class.bg-zinc-50/90]="!widgetDarkTheme()"
                                        [class.text-zinc-900]="!widgetDarkTheme()"
                                        [class.placeholder-zinc-400]="!widgetDarkTheme()"
                                        [class.focus:border-[var(--tg-accent)]/60]="!widgetDarkTheme()"
                                        [class.focus:ring-[var(--tg-accent)]/20]="!widgetDarkTheme()"
                                        [class.border-red-400/60]="preChatError()"
                                        [class.border-white/10]="widgetDarkTheme()"
                                        [class.bg-neutral-950]="widgetDarkTheme()"
                                        [class.text-white]="widgetDarkTheme()"
                                        [class.placeholder-neutral-500]="widgetDarkTheme()"
                                        [class.focus:border-[var(--tg-accent)]/50]="widgetDarkTheme()"
                                        [class.focus:ring-[var(--tg-accent)]/25]="widgetDarkTheme()" />
                                </div>
                                <div>
                                    <label class="block text-[14px] font-bold mb-1.5 tracking-wide"
                                        [class.text-zinc-600]="!widgetDarkTheme()"
                                        [class.text-neutral-400]="widgetDarkTheme()">Email</label>
                                    <input type="email" [ngModel]="preChatEmail()"
                                        (ngModelChange)="preChatEmail.set($event); validatePreChat()" name="emailInput"
                                        placeholder="Email address" autocomplete="email"
                                        class="tg-prechat-input w-full h-11 px-3.5 rounded-xl border text-[15px] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0"
                                        [class.border-zinc-200]="!widgetDarkTheme()"
                                        [class.bg-zinc-50/90]="!widgetDarkTheme()"
                                        [class.text-zinc-900]="!widgetDarkTheme()"
                                        [class.placeholder-zinc-400]="!widgetDarkTheme()"
                                        [class.focus:border-[var(--tg-accent)]/60]="!widgetDarkTheme()"
                                        [class.focus:ring-[var(--tg-accent)]/20]="!widgetDarkTheme()"
                                        [class.border-red-400/60]="preChatError()"
                                        [class.border-white/10]="widgetDarkTheme()"
                                        [class.bg-neutral-950]="widgetDarkTheme()"
                                        [class.text-white]="widgetDarkTheme()"
                                        [class.placeholder-neutral-500]="widgetDarkTheme()"
                                        [class.focus:border-[var(--tg-accent)]/50]="widgetDarkTheme()"
                                        [class.focus:ring-[var(--tg-accent)]/25]="widgetDarkTheme()" />
                                </div>
                                <div class="relative z-20">
                                    <label class="block text-[14px] font-bold mb-1.5 tracking-wide"
                                        [class.text-zinc-600]="!widgetDarkTheme()"
                                        [class.text-neutral-400]="widgetDarkTheme()">Phone number</label>
                                    <div #countryPickerRoot class="relative">
                                        <div class="flex rounded-xl border overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-offset-0"
                                            [class.border-zinc-200]="!widgetDarkTheme()"
                                            [class.focus-within:border-[var(--tg-accent)]/55]="!widgetDarkTheme()"
                                            [class.focus-within:ring-[var(--tg-accent)]/20]="!widgetDarkTheme()"
                                            [class.border-red-400/60]="preChatError()"
                                            [class.border-white/10]="widgetDarkTheme()"
                                            [class.focus-within:ring-[var(--tg-accent)]/25]="widgetDarkTheme()">
                                            <button type="button" (click)="toggleCountryDropdown($event)"
                                                class="shrink-0 min-w-[7.5rem] max-w-[10rem] h-11 pl-2 pr-1.5 flex items-center justify-between gap-1.5 text-xs font-semibold border-0 border-r cursor-pointer focus:ring-0 focus:outline-none text-left tracking-tight"
                                                [class.bg-zinc-100]="!widgetDarkTheme()"
                                                [class.text-zinc-800]="!widgetDarkTheme()"
                                                [class.border-zinc-200]="!widgetDarkTheme()"
                                                [class.bg-neutral-900]="widgetDarkTheme()"
                                                [class.text-neutral-200]="widgetDarkTheme()"
                                                [class.border-white/10]="widgetDarkTheme()"
                                                aria-haspopup="listbox"
                                                [attr.aria-expanded]="countryDropdownOpen()">
                                                <span class="flex min-w-0 items-center gap-1.5">
                                                    @if (phoneCountryFlagUrl(preChatCountryIso()); as flagSrc) {
                                                    <img [src]="flagSrc" width="20" height="15" alt=""
                                                        class="shrink-0 h-[15px] w-5 rounded-[2px] object-cover ring-1 ring-black/10 dark:ring-white/15"
                                                        loading="eager" decoding="async" referrerpolicy="no-referrer" />
                                                    } @else {
                                                    <i class="fa-solid fa-globe shrink-0 w-5 text-center text-[13px] opacity-70"
                                                        aria-hidden="true"></i>
                                                    }
                                                    <span class="truncate tabular-nums">{{ countryTriggerLabel() }}</span>
                                                </span>
                                                <i class="fa-solid fa-chevron-down text-[10px] opacity-55 shrink-0"></i>
                                            </button>
                                            <input type="tel" [ngModel]="preChatPhoneLocal()"
                                                (ngModelChange)="onPreChatPhoneInput($event)"
                                                name="phoneLocal" placeholder="Phone number" inputmode="tel"
                                                autocomplete="tel-national"
                                                class="flex-1 min-w-0 h-11 px-3 border-0 text-[15px] focus:ring-0 focus:outline-none"
                                                [class.bg-zinc-50/90]="!widgetDarkTheme()"
                                                [class.text-zinc-900]="!widgetDarkTheme()"
                                                [class.placeholder-zinc-400]="!widgetDarkTheme()"
                                                [class.bg-neutral-950]="widgetDarkTheme()"
                                                [class.text-white]="widgetDarkTheme()"
                                                [class.placeholder-neutral-500]="widgetDarkTheme()" />
                                        </div>
                                        @if (countryDropdownOpen()) {
                                        <div
                                            class="absolute left-0 right-0 top-full mt-1 z-[200] rounded-xl border shadow-xl flex flex-col max-h-[min(280px,42vh)] overflow-hidden"
                                            [class.border-zinc-200]="!widgetDarkTheme()"
                                            [class.bg-white]="!widgetDarkTheme()"
                                            [class.border-white/15]="widgetDarkTheme()"
                                            [class.bg-neutral-900]="widgetDarkTheme()"
                                            role="listbox">
                                            <div class="p-2 border-b shrink-0"
                                                [class.border-zinc-200]="!widgetDarkTheme()"
                                                [class.border-white/10]="widgetDarkTheme()">
                                                <input type="search" name="countrySearch"
                                                    placeholder="Search country"
                                                    [ngModel]="countrySearchQuery()"
                                                    (ngModelChange)="onCountrySearchInput($event)"
                                                    (click)="$event.stopPropagation()"
                                                    class="w-full h-9 px-2.5 rounded-lg border text-sm focus:outline-none focus:ring-2"
                                                    [class.border-zinc-200]="!widgetDarkTheme()"
                                                    [class.bg-zinc-50]="!widgetDarkTheme()"
                                                    [class.text-zinc-900]="!widgetDarkTheme()"
                                                    [class.focus:border-[var(--tg-accent)]/50]="!widgetDarkTheme()"
                                                    [class.focus:ring-[var(--tg-accent)]/15]="!widgetDarkTheme()"
                                                    [class.border-white/10]="widgetDarkTheme()"
                                                    [class.bg-neutral-950]="widgetDarkTheme()"
                                                    [class.text-white]="widgetDarkTheme()"
                                                    [class.focus:border-[var(--tg-accent)]/40]="widgetDarkTheme()"
                                                    [class.focus:ring-[var(--tg-accent)]/20]="widgetDarkTheme()"
                                                    autocomplete="off" />
                                            </div>
                                            <ul class="overflow-y-auto tg-scroll-light flex-1 min-h-0 py-1"
                                                [class.text-zinc-900]="!widgetDarkTheme()"
                                                [class.text-neutral-100]="widgetDarkTheme()">
                                                @for (c of filteredPhoneCountries(); track c.iso2) {
                                                <li>
                                                    <button type="button"
                                                        (click)="selectPhoneCountry(c, $event)"
                                                        class="w-full flex items-center gap-2.5 px-2.5 py-2.5 text-left text-[13px] transition-colors"
                                                        [ngClass]="widgetDarkTheme() ? 'hover:bg-white/5' : 'hover:bg-zinc-100'">
                                                        @if (phoneCountryFlagUrl(c.iso2); as rowFlagSrc) {
                                                        <img [src]="rowFlagSrc" width="24" height="18" alt=""
                                                            class="shrink-0 h-[18px] w-6 rounded-[2px] object-cover ring-1 ring-black/10 dark:ring-white/15"
                                                            loading="lazy" decoding="async" referrerpolicy="no-referrer" />
                                                        } @else {
                                                        <i class="fa-solid fa-globe shrink-0 w-6 text-center text-[15px] opacity-70"
                                                            aria-hidden="true"></i>
                                                        }
                                                        <span class="flex-1 min-w-0 truncate">{{ c.name }}</span>
                                                        <span class="shrink-0 text-[12px] tabular-nums opacity-65">{{ c.dial }}</span>
                                                    </button>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if (preChatError()) {
                                <div class="flex gap-2 rounded-xl border px-3 py-2.5 text-[13px] leading-snug"
                                    [class.bg-red-50]="!widgetDarkTheme()"
                                    [class.text-red-700]="!widgetDarkTheme()"
                                    [class.border-red-100]="!widgetDarkTheme()"
                                    [class.bg-red-950/40]="widgetDarkTheme()"
                                    [class.text-red-300]="widgetDarkTheme()"
                                    [class.border-red-500/25]="widgetDarkTheme()"
                                    role="alert">
                                    <i class="fa-solid fa-circle-exclamation mt-0.5 shrink-0 text-[14px] opacity-90"></i>
                                    <span class="m-0">{{ preChatError() }}</span>
                                </div>
                                }
                                <div class="space-y-2 pt-1">
                                    @if (widgetConfig()?.voiceEnabled) {
                                    <button type="button"
                                        (click)="submitPreChatAndStart(chatWidgetType.ChatWidgetAudio)"
                                        [disabled]="startingChatMode() !== null"
                                        [class.opacity-60]="startingChatMode() !== null"
                                        [class.cursor-not-allowed]="startingChatMode() !== null"
                                        class="w-full py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-2 shadow-sm transition-all duration-200 hover:brightness-110 active:scale-95 disabled:opacity-45 disabled:cursor-not-allowed disabled:shadow-none"
                                        [style.background]="metaPrimary()" [style.color]="preChatContinueTextColor()">
                                        @if (startingChatMode() === chatWidgetType.ChatWidgetAudio) {
                                        <span class="animate-spin inline-block h-4 w-4 rounded-full border-2 border-t-transparent"
                                            [class.border-white/60]="widgetDarkTheme()"
                                            [class.border-zinc-300]="!widgetDarkTheme()"></span>
                                        <span>Starting…</span>
                                        } @else {
                                        <i class="fa-solid fa-microphone"></i>
                                        <span>Start with Voice</span>
                                        }
                                    </button>
                                    }
                                    @if (widgetConfig()?.messageEnabled) {
                                    <button type="button"
                                        (click)="submitPreChatAndStart(chatWidgetType.ChatWidgetText)"
                                        [disabled]="startingChatMode() !== null"
                                        [class.opacity-60]="startingChatMode() !== null"
                                        [class.cursor-not-allowed]="startingChatMode() !== null"
                                        class="w-full py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-2 transition-colors cursor-pointer disabled:opacity-45 disabled:cursor-not-allowed text-lg"
                                        [class.border-2]="widgetConfig()?.voiceEnabled"
                                        [class.shadow-sm]="!widgetConfig()?.voiceEnabled"
                                        [class.hover:brightness-110]="!widgetConfig()?.voiceEnabled"
                                        [class.active:scale-95]="!widgetConfig()?.voiceEnabled"
                                        [class.bg-transparent]="widgetConfig()?.voiceEnabled"
                                        [class.hover:bg-zinc-100]="widgetConfig()?.voiceEnabled && !widgetDarkTheme()"
                                        [class.hover:bg-white/5]="widgetConfig()?.voiceEnabled && widgetDarkTheme()"
                                        [style.background]="widgetConfig()?.voiceEnabled ? 'transparent' : metaPrimary()"
                                        [style.borderColor]="widgetConfig()?.voiceEnabled ? metaPrimary() : null"
                                        [style.color]="widgetConfig()?.voiceEnabled ? metaPrimary() : preChatContinueTextColor()">
                                        @if (startingChatMode() === chatWidgetType.ChatWidgetText) {
                                        <span class="animate-spin inline-block h-4 w-4 rounded-full border-2 border-t-transparent"
                                            [class.border-white/60]="widgetDarkTheme()"
                                            [class.border-zinc-300]="!widgetDarkTheme()"></span>
                                        <span>Starting…</span>
                                        } @else {
                                        <i class="fa-solid fa-comments"></i>
                                        <span class="text-lg">Start with Chat</span>
                                        }
                                    </button>
                                    }
                                    @if (!widgetConfig()?.voiceEnabled && !widgetConfig()?.messageEnabled) {
                                    <button type="submit" [disabled]="!isPreChatValid()"
                                        class="w-full h-12 rounded-xl text-[15px] font-semibold shadow-md transition-all duration-200 hover:brightness-[1.02] active:scale-[0.99] disabled:opacity-45 disabled:cursor-not-allowed"
                                        [style.background]="metaPrimary()" [style.color]="preChatContinueTextColor()">
                                        Continue
                                    </button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                    } @else {
                    <div class="flex flex-col items-center text-center flex-1 pt-2 pb-2">
                        <div class="relative mb-3">
                            <div class="w-20 h-20 rounded-full p-[3px] shadow-lg"
                                [style.background]="'linear-gradient(135deg, ' + metaPrimary() + 'aa, ' + metaPrimary() + '33)'">
                                <img
                                    [src]="widgetBotAvatarSrc()"
                                    alt="" class="w-full h-full object-cover rounded-full" />
                            </div>
                            <span
                                class="absolute bottom-0.5 right-0.5 w-3.5 h-3.5 rounded-full bg-emerald-400 ring-2"
                                [class.ring-white]="!widgetDarkTheme()" [class.ring-zinc-950]="widgetDarkTheme()"></span>
                        </div>
                        <div class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold mb-3 border"
                            [style.background]="metaPrimary() + '18'"
                            [style.color]="metaPrimary()"
                            [style.borderColor]="metaPrimary() + '40'">
                            <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 shrink-0"></span>
                            Online
                        </div>
                        <h2 class="text-xl font-semibold m-0 mb-2 max-w-[16rem] leading-tight"
                            [style.color]="widgetHeadingTextColor()">
                            {{ welcomeHeadline() }}
                        </h2>
                        <p class="text-sm m-0 mb-5 max-w-[18rem] leading-relaxed"
                            [class.text-zinc-600]="!widgetDarkTheme()" [class.text-neutral-500]="widgetDarkTheme()">
                            {{ welcomeSubcopy() }}
                        </p>

                        
                    </div>
                    }

                    @if (!showPreChatForm() && isPreChatValid()) {
                    <div class="shrink-0 w-full max-w-sm mx-auto space-y-2 mb-4">
                        @if (widgetConfig()?.voiceEnabled) {
                        <button type="button" (click)="startSession(chatWidgetType.ChatWidgetAudio)"
                            [disabled]="startingChatMode() !== null || isSocketRequestInProcess()"
                            [class.opacity-60]="startingChatMode() !== null || isSocketRequestInProcess()"
                            [class.cursor-not-allowed]="startingChatMode() !== null || isSocketRequestInProcess()"
                            class="w-full py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-2 cursor-pointer"
                            [style.background]="metaPrimary()"
                            [style.color]="metaSecondary()">
                             @if (startingChatMode() === chatWidgetType.ChatWidgetAudio) {
                            <span class="inline-flex items-center gap-2">
                                <span
                                    class="animate-spin inline-block h-4 w-4 rounded-full border-2 border-t-transparent"
                                    [class.border-white/60]="widgetDarkTheme()"
                                    [class.border-zinc-300]="!widgetDarkTheme()"></span>
                                <span>{{ isSocketRequestInProcess() ? 'Connecting…' : 'Starting…' }}</span>
                            </span>
                            } @else {
                            <i class="fa-solid fa-microphone"></i>
                            <span>Start with Voice</span>
                            }
                        </button>
                        }
                        @if (widgetConfig()?.messageEnabled) {
                        <button type="button" (click)="startSession(chatWidgetType.ChatWidgetText)"
                            [disabled]="startingChatMode() !== null || isSocketRequestInProcess()"
                            [class.opacity-60]="startingChatMode() !== null || isSocketRequestInProcess()"
                            [class.cursor-not-allowed]="startingChatMode() !== null || isSocketRequestInProcess()"
                            class="w-full py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-2 transition-colors cursor-pointer"
                            [class.border-2]="widgetConfig()?.voiceEnabled"
                            [class.bg-transparent]="widgetConfig()?.voiceEnabled"
                            [class.hover:bg-zinc-100]="widgetConfig()?.voiceEnabled && !widgetDarkTheme()"
                            [class.hover:bg-white/5]="widgetConfig()?.voiceEnabled && widgetDarkTheme()"
                            [style.background]="widgetConfig()?.voiceEnabled ? 'transparent' : metaPrimary()"
                            [style.borderColor]="widgetConfig()?.voiceEnabled ? metaPrimary() : null"
                            [style.color]="widgetConfig()?.voiceEnabled ? metaPrimary() : metaSecondary()">
                            @if (startingChatMode() === chatWidgetType.ChatWidgetText) {
                            <span class="inline-flex items-center gap-2">
                                <span
                                    class="animate-spin inline-block h-4 w-4 rounded-full border-2 border-t-transparent"
                                    [class.border-white/60]="widgetDarkTheme()"
                                    [class.border-zinc-300]="!widgetDarkTheme()"></span>
                                <span>{{ isSocketRequestInProcess() ? 'Connecting…' : 'Starting…' }}</span>
                            </span>
                            } @else {
                            <i class="fa-solid fa-comments"></i>
                            <span>Start with Chat</span>
                            }
                        </button>
                        }

                    </div>
                    }

                  
                    <p class="text-[14px] text-center mt-1 m-0"
                        [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-600]="widgetDarkTheme()">
                        Powered by
                        <a href="https://talkgenie.ai/" target="_blank" rel="noopener noreferrer"
                            class="underline underline-offset-2 hover:opacity-90"
                            [style.color]="metaAction()">talkgenie.ai</a>
                    </p>
                </div>
                }
            </div>

          
            @if (sessionStarted() && !showFeedbackForm()) {
                <p class="text-[14px] text-center mt-1 m-0"
                        [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-600]="widgetDarkTheme()">
                        Powered by
                        <a href="https://talkgenie.ai/" target="_blank" rel="noopener noreferrer"
                            class="underline underline-offset-2 hover:opacity-90"
                            [style.color]="metaAction()">talkgenie.ai</a>
                    </p>
            <div class="shrink-0 px-3 pt-2 pb-3 border-t"
                [style.background]="widgetBackgroundColor()"
                [class.border-zinc-200]="!widgetDarkTheme()" [class.bg-white]="!widgetDarkTheme()"
                [class.border-white/10]="widgetDarkTheme()" [class.bg-neutral-900]="widgetDarkTheme()">
                
                @if (isChatMode()) {
                <input #visitorAttachmentInput type="file" class="sr-only" tabindex="-1" aria-hidden="true"
                    [accept]="isHumanAgentPresent() ? '*/*' : 'image/*'"
                    (change)="onVisitorAttachmentSelected($event)" />
                <form (ngSubmit)="sendMessage()" class="sticky bottom-0 p-3"
                    [style.background]="widgetBackgroundColor()"
                    [class.border-zinc-200]="!widgetDarkTheme()" [class.bg-white]="!widgetDarkTheme()"
                    [class.border-white/10]="widgetDarkTheme()" [class.bg-zinc-900]="widgetDarkTheme()">
                    @if (attachmentError()) {
                    <p class="text-[12px] mb-1 px-1"
                        [class.text-red-600]="!widgetDarkTheme()"
                        [class.text-red-400]="widgetDarkTheme()">{{ attachmentError() }}</p>
                    }
                    @if (voiceError()) {
                    <p class="text-[12px] mb-1 px-1"
                        [class.text-red-600]="!widgetDarkTheme()"
                        [class.text-red-400]="widgetDarkTheme()">{{ voiceError() }}</p>
                    }

                    <!-- ── RECORDING state ── -->
                    @if (isVoiceRecording()) {
                    <div class="flex items-center gap-3 px-1 mb-2">
                        <span class="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse shrink-0"></span>
                        <!-- Animated waveform bars -->
                        <div class="flex items-center gap-[3px] flex-1">
                            @for (h of [10,16,22,14,20,12,18,10,16,22,14,20,12,18,10,16]; track $index) {
                            <span class="rounded-full tg-voice-bar"
                                [style.height.px]="h"
                                [style.animation-delay]="($index * 0.07) + 's'"
                                [class.bg-red-400]="!widgetDarkTheme()"
                                [class.bg-red-500]="widgetDarkTheme()"
                                style="width:3px;display:inline-block;">
                            </span>
                            }
                        </div>
                        <span class="text-[13px] font-mono font-semibold text-red-500 tabular-nums shrink-0">{{ formatRecordingTime(voiceRecordingSeconds()) }}</span>
                        <button type="button" (click)="toggleVoiceRecord()"
                            [disabled]="isSocketRequestInProcess() || voiceProcessing()"
                            class="w-8 h-8 shrink-0 flex items-center justify-center rounded-lg transition-colors disabled:opacity-40"
                            [class.text-red-600]="!widgetDarkTheme()"
                            [class.text-red-400]="widgetDarkTheme()"
                            [class.hover:bg-red-50]="!widgetDarkTheme()"
                            [class.hover:bg-red-500/10]="widgetDarkTheme()"
                            title="Stop recording" aria-label="Stop recording">
                            <i class="fa-solid fa-stop text-xs"></i>
                        </button>
                    </div>
                    }

                    <!-- ── Attachment preview (confirm before upload/send) ── -->
                    @if (visitorAttachmentPreviewFile(); as visAttFile) {
                    <div class="flex items-center gap-2 mb-2 px-1">
                        <button type="button" (click)="cancelVisitorAttachmentPreview()"
                            [disabled]="attachmentUploading()"
                            class="w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-colors disabled:opacity-30"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.hover:bg-zinc-100]="!widgetDarkTheme()"
                            [class.text-neutral-400]="widgetDarkTheme()" [class.hover:bg-white/10]="widgetDarkTheme()"
                            title="Discard attachment" aria-label="Discard attachment">
                            <i class="fa-solid fa-trash text-[13px]"></i>
                        </button>
                        <div class="w-fit max-w-full min-w-0 rounded-2xl"
                            [class.px-3]="!visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()"
                            [class.py-2]="!visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()"
                            [class.ring-1]="!visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()"
                            [class.bg-zinc-50]="!widgetDarkTheme() && !visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()"
                            [class.ring-zinc-200]="!widgetDarkTheme() && !visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()"
                            [class.bg-white/5]="widgetDarkTheme() && !visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()"
                            [class.ring-white/10]="widgetDarkTheme() && !visitorAttachmentPreviewIsImage() && !visitorAttachmentPreviewIsVideo()">
                            @if (visitorAttachmentPreviewUrl() && visitorAttachmentPreviewIsImage()) {
                            <img [src]="visitorAttachmentPreviewUrl()" [alt]="visAttFile.name"
                                class="block max-h-32 w-auto max-w-full rounded-lg object-contain" />
                            } @else if (visitorAttachmentPreviewUrl() && visitorAttachmentPreviewIsVideo()) {
                            <video controls playsinline [src]="visitorAttachmentPreviewUrl()"
                                class="block max-h-32 w-full max-w-full rounded-lg"></video>
                            } @else {
                            <div class="flex items-center gap-2 min-w-0">
                                <i class="fa-solid fa-file text-[11px] shrink-0"
                                    [class.text-zinc-400]="!widgetDarkTheme()"
                                    [class.text-neutral-500]="widgetDarkTheme()"></i>
                                <span class="text-[12px] truncate"
                                    [class.text-zinc-700]="!widgetDarkTheme()"
                                    [class.text-neutral-200]="widgetDarkTheme()">{{ visAttFile.name }}</span>
                            </div>
                            }
                        </div>
                    </div>
                    }

                    <!-- ── PREVIEW state (recorded, waiting for send/delete) ── -->
                    @if (!isVoiceRecording() && voicePreviewBlobUrl()) {
                    <div class="flex items-center gap-2 mb-2 px-1">
                        <!-- Delete button (disabled while uploading) -->
                        <button type="button" (click)="cancelVoicePreview()"
                            [disabled]="voiceProcessing()"
                            class="w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-colors disabled:opacity-30"
                            [class.text-zinc-500]="!widgetDarkTheme()" [class.hover:bg-zinc-100]="!widgetDarkTheme()"
                            [class.text-neutral-400]="widgetDarkTheme()" [class.hover:bg-white/10]="widgetDarkTheme()"
                            title="Discard recording" aria-label="Discard recording">
                            <i class="fa-solid fa-trash text-[13px]"></i>
                        </button>
                        <!-- Audio preview player -->
                        <div class="flex-1 min-w-0 rounded-2xl px-3 py-2 ring-1"
                            [class.bg-zinc-50]="!widgetDarkTheme()" [class.ring-zinc-200]="!widgetDarkTheme()"
                            [class.bg-white/5]="widgetDarkTheme()" [class.ring-white/10]="widgetDarkTheme()">
                            <div class="flex items-center gap-2">
                                <i class="fa-solid fa-microphone text-[11px] shrink-0"
                                    [class.text-zinc-400]="!widgetDarkTheme()"
                                    [class.text-neutral-500]="widgetDarkTheme()"></i>
                                <audio controls [src]="voicePreviewBlobUrl()"
                                    class="w-full" style="height:28px;min-width:0;" preload="auto"></audio>
                            </div>
                            <p class="text-[11px] mt-1 tabular-nums"
                                [class.text-zinc-400]="!widgetDarkTheme()"
                                [class.text-neutral-500]="widgetDarkTheme()">
                                {{ formatRecordingTime(voicePreviewDurationSec()) }}
                            </p>
                        </div>
                        <!-- Send button -->
                        <button type="button" (click)="sendVoiceMessage()"
                            [disabled]="voiceProcessing()"
                            class="w-9 h-9 shrink-0 flex items-center justify-center rounded-xl transition-all disabled:opacity-40 hover:brightness-110 active:scale-95 shadow-sm"
                            [style.background]="metaPrimary()"
                            [style.color]="metaSecondary()"
                            title="Send voice message" aria-label="Send voice message">
                            @if (voiceProcessing()) {
                            <span class="inline-block h-4 w-4 rounded-full border-2 border-t-transparent animate-spin border-current"></span>
                            } @else {
                            <i class="fa-solid fa-paper-plane text-sm -translate-x-px"></i>
                            }
                        </button>
                    </div>
                    }

                    <!-- ── Composer row (hidden while recording / voice preview; stays visible for attachment caption) ── -->
                    @if (!isVoiceRecording() && !voicePreviewBlobUrl()) {
                    <div class="flex items-center justify-between gap-2">
                        <div class="relative w-full">
                            <button type="button" (click)="toggleVoiceRecord()"
                                [disabled]="isSocketRequestInProcess() || voiceProcessing()"
                                class="absolute left-1 top-1/2 -translate-y-1/2 sm:left-3 w-7 h-7 flex items-center justify-center rounded-md transition-colors disabled:opacity-40"
                                [class.text-zinc-600]="!widgetDarkTheme()"
                                [class.text-neutral-300]="widgetDarkTheme()"
                                [class.hover:bg-zinc-100]="!widgetDarkTheme()"
                                [class.hover:bg-white/10]="widgetDarkTheme()"
                                title="Record a voice message" aria-label="Voice message">
                                <i class="fa-solid fa-microphone text-sm"></i>
                            </button>
                            <input type="text" [ngModel]="userTextMessage()" (ngModelChange)="onVisitorMessageInput($event)"
                                (paste)="onVisitorPaste($event)"
                                name="messageInput"
                                [placeholder]="composerPlaceholder()"
                                [disabled]="isSocketRequestInProcess() || attachmentUploading()"
                                class="h-9 w-full border-none bg-transparent pl-10 pr-3 text-sm outline-hidden focus:border-0 focus:ring-0 sm:pl-12"
                                [class.text-black]="!widgetDarkTheme()" [class.placeholder-surface-400]="!widgetDarkTheme()"
                                [class.text-white]="widgetDarkTheme()" [class.placeholder-surface-500]="widgetDarkTheme()"
                                aria-label="Message" />
                        </div>
                        <div class="flex items-center shrink-0"
                            [class.text-zinc-500]="!widgetDarkTheme()"
                            [class.text-neutral-400]="widgetDarkTheme()">
                            <button type="button" (click)="openVisitorAttachmentPicker()"
                                [disabled]="isSocketRequestInProcess() || attachmentUploading() || !!visitorAttachmentPreviewFile()"
                                class="mr-2 w-9 h-9 flex items-center justify-center rounded-lg transition-colors disabled:opacity-40"
                                [class.text-zinc-600]="!widgetDarkTheme()"
                                [class.hover:bg-zinc-100]="!widgetDarkTheme()"
                                [class.text-neutral-300]="widgetDarkTheme()"
                                [class.hover:bg-white/10]="widgetDarkTheme()"
                                [title]="isHumanAgentPresent() ? 'Attach a file' : 'Attach an image for the AI assistant'"
                                aria-label="Attach file">
                                @if (attachmentUploading()) {
                                <span
                                    class="inline-block h-4 w-4 rounded-full border-2 border-t-transparent animate-spin"
                                    [class.border-zinc-400]="!widgetDarkTheme()"
                                    [class.border-neutral-500]="widgetDarkTheme()"></span>
                                } @else {
                                <i class="fa-solid fa-paperclip text-sm"></i>
                                }
                            </button>
                            @if (!isVoiceRecording()) {
                            <button type="submit"
                                [disabled]="isSocketRequestInProcess() || attachmentUploading() || !canSendMessage()"
                                class="ml-3 xl:ml-5 w-9 h-9 flex items-center justify-center rounded-lg transition-all disabled:opacity-25 disabled:cursor-not-allowed hover:brightness-110 active:scale-95"
                                [style.background]="metaPrimary()"
                                [style.color]="metaSecondary()"
                                [attr.aria-label]="visitorAttachmentPreviewFile() ? 'Send image and caption' : 'Send'">
                                @if (attachmentUploading()) {
                                <span
                                    class="inline-block h-4 w-4 rounded-full border-2 border-t-transparent animate-spin border-current"></span>
                                } @else {
                                <i class="fa-solid fa-paper-plane text-sm -translate-x-px"></i>
                                }
                            </button>
                            }
                        </div>
                    </div>
                    }
                </form>
                <p class="text-[14px] text-center mt-2.5 leading-relaxed px-2"
                    [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-600]="widgetDarkTheme()">
                    <span [innerHTML]="footerHtml()"></span>
                </p>

                } @else if (isAudioMode()) {
                <div class="flex items-center justify-between gap-3 px-1 py-2">
                    <span class="text-[13px] font-medium truncate"
                        [class.text-zinc-600]="!widgetDarkTheme()" [class.text-neutral-400]="widgetDarkTheme()">Voice
                        call</span>
                    <button type="button" (click)="endSession()"
                        class="shrink-0 px-4 py-2 rounded-full text-sm font-medium text-white bg-red-500 hover:bg-red-600 transition-colors"
                        title="End call" aria-label="End call">
                        End call
                    </button>
                </div>
                <p class="text-[10px] text-center mt-1 leading-relaxed px-2"
                    [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-600]="widgetDarkTheme()">
                    <span [innerHTML]="footerHtml()"></span>
                </p>
                <p class="text-[10px] text-center mt-1 leading-relaxed px-2"
                    [class.text-zinc-500]="!widgetDarkTheme()" [class.text-neutral-600]="widgetDarkTheme()">
                    Powered by
                    <a href="https://talkgenie.ai/" target="_blank" rel="noopener noreferrer"
                        class="underline underline-offset-2"
                        [class.hover:text-zinc-700]="!widgetDarkTheme()"
                        [class.hover:text-neutral-500]="widgetDarkTheme()">talkgenie.ai</a>
                </p>
                } @else {
                <div class="flex flex-col items-stretch gap-2 px-1 py-2">
                    <p class="text-[12px] m-0"
                        [class.text-zinc-600]="!widgetDarkTheme()" [class.text-neutral-400]="widgetDarkTheme()">End this
                        session when you’re done.</p>
                    <button type="button" (click)="endSession()"
                        class="w-full py-2.5 rounded-xl text-sm font-medium text-white bg-red-500 hover:bg-red-600 transition-colors"
                        title="End chat" aria-label="End chat">
                        End chat
                    </button>
                </div>
                }
            </div>
            }
        </div>
    </div>
    }

    @if (!isOpen() && !isStyleOnlyDashboardPreview()) {
    <div class="relative flex flex-col items-end box-border min-h-0 min-w-0">
            
            @if (unreadWhileMinimized() > 0) {
            <span class="tg-launcher-unread-badge" aria-hidden="true">{{ unreadBadgeLabel() }}</span>
            }
            <!-- <button type="button"
                class="tg-widget-launcher-btn relative box-border min-h-0 min-w-0 cursor-pointer rounded-full outline-none transition-transform duration-200 hover:scale-105 focus-visible:ring-2 focus-visible:ring-[var(--tg-accent)] focus-visible:ring-offset-0 w-[68px] w-[68px]"
                [style.background]="metaBubbleColor()"
                [style.box-shadow]="'0 4px 16px rgba(0,0,0,.45), 0 0 0 1px rgba(0,0,0,.35)'"
                [style.borderRadius]="launcherBorderRadiusCss()"
                (click)="toggleChat()"
                [attr.aria-label]="unreadWhileMinimized() > 0 ? ('Open chat, ' + unreadWhileMinimized() + ' unread') : 'Open chat'">
                <img [src]="widgetBotAvatarSrc()" alt=""
                    [style.borderRadius]="launcherBorderRadiusCss()"
                    class="tg-widget-launcher-img block h-full w-full rounded-full box-border" />
            </button> -->
    </div>
    }

    @if (isStyleOnlyDashboardPreview()) {
    <div
        class="relative mt-3 flex w-full items-center"
        [ngClass]="(widgetConfig()?.metaData?.widgetPosition ?? position()) === 'bottom-left' || (widgetConfig()?.metaData?.widgetPosition ?? position()) === 'top-left'
            ? 'justify-start'
            : 'justify-end'">
        <div class="flex flex-col items-center gap-1.5 shrink-0">
            @if (popupVisible() && widgetConfig()?.metaData?.popupMessageText; as popupText) {
            <div class="shrink-0 animate-popup-in">
                <div class="relative rounded-xl px-4 py-2.5 text-sm leading-snug font-medium shadow-lg text-center max-w-[200px] bg-white text-[#0f172a]">
                    {{ popupText }}
                    <div class="absolute -bottom-[6px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[7px] border-r-[7px] border-t-[7px] border-l-transparent border-r-transparent border-t-white"></div>
                </div>
            </div>
            }
            <button
                type="button"
                class="tg-widget-launcher-btn relative h-[68px] w-[68px] shrink-0 cursor-default rounded-full outline-none"
                [style.background]="metaBubbleColor()"
                [style.box-shadow]="'0 4px 16px rgba(0,0,0,.45), 0 0 0 1px rgba(0,0,0,.35)'"
                [style.borderRadius]="launcherBorderRadiusCss()"
                aria-label="Launcher preview"
                tabindex="-1">
                <img [src]="widgetBotAvatarSrc()" alt=""
                    [style.borderRadius]="launcherBorderRadiusCss()"
                    class="tg-widget-launcher-img block h-full w-full rounded-full box-border" />
            </button>
        </div>
    </div>
    }

    @if (lightboxImageUrl()) {
    <div class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/90 backdrop-blur-sm"
        (click)="closeLightbox()" role="dialog" aria-modal="true" aria-label="Image viewer">
        <button class="absolute top-[max(1rem,env(safe-area-inset-top,0px))] right-[max(1rem,env(safe-area-inset-right,0px))] w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors text-lg z-10"
            (click)="closeLightbox()" aria-label="Close image viewer">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <img [src]="lightboxImageUrl()!" alt="Full size image"
            class="max-w-[90vw] max-h-[min(90dvh,calc(100dvh-env(safe-area-inset-top,0px)-env(safe-area-inset-bottom,0px)-2rem))] object-contain rounded-lg shadow-2xl"
            (click)="$event.stopPropagation()"
            referrerpolicy="no-referrer" />
    </div>
    }
</div>
